(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6480],{

/***/ 94161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);


var redirectFirstPage = function redirectFirstPage(_ref) {
  var page = _ref.page,
      res = _ref.res,
      asPath = _ref.asPath;

  if (+page === 1) {
    // eslint-disable-next-line no-useless-escape
    var redirectUrl = asPath.replace(/[&\?]?page=1[&]?/gm, function (match) {
      if (match === '&page=1') return '';
      if (match === '?page=1') return '';
      if (match === '?page=1&') return '?';
    });

    if (res) {
      res.writeHead(301, {
        Location: redirectUrl
      });
      res.end();
    } else {
      next_router__WEBPACK_IMPORTED_MODULE_0___default().push(redirectUrl);
    }
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (redirectFirstPage);

/***/ }),

/***/ 60202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NextSpecialOffersPage; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shopify_react_idle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17548);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70517);
/* harmony import */ var _containers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21341);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_pagesSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66681);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _lib_redirectFirstPage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94161);
/* harmony import */ var _lib_handleError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67408);
/* harmony import */ var _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var SpecialOffersPage = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 2585).then(__webpack_require__.bind(__webpack_require__, 32585));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Loader */ .aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(32585)];
    }
  }
});
function NextSpecialOffersPage(props) {
  var setPageType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function () {
    _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__/* ["default"].setPageType */ .ZP.setPageType(_seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__/* ["default"].PAGE_TYPES.SPECIAL */ .ZP.PAGE_TYPES.SPECIAL);
  }, []);
  (0,_shopify_react_idle__WEBPACK_IMPORTED_MODULE_12__/* .useIdleCallback */ .Y)(setPageType);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_5__/* .MetaData */ .U4, {
      title: "\u0410\u043A\u0446\u0438\u0438 | FH.BY",
      description: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435 \u0438 \u0431\u0443\u0434\u0443\u0449\u0438\u0435 \u0410\u043A\u0446\u0438\u0438 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430 FH.BY!",
      seo: props === null || props === void 0 ? void 0 : props.seo,
      withPage: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(SpecialOffersPage, _objectSpread({}, props))]
  });
}

NextSpecialOffersPage.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var _pageData$data;

    var reduxStore, query, res, asPath, _qs$parse, page, pageData;

    return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reduxStore = _ref.reduxStore, query = _ref.query, res = _ref.res, asPath = _ref.asPath;
            _qs$parse = qs__WEBPACK_IMPORTED_MODULE_7___default().parse(query), page = _qs$parse.page;
            (0,_lib_redirectFirstPage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
              page: page,
              res: res,
              asPath: asPath
            });
            _context.next = 5;
            return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_pagesSlice__WEBPACK_IMPORTED_MODULE_6__/* .fetchSpecialOffers */ .Zg)({
              page: page || 1,
              per_page: 6
            }));

          case 5:
            pageData = (0,_fh_components_fh_js_api_core_store_slices_pagesSlice__WEBPACK_IMPORTED_MODULE_6__/* .getSpecialOffersData */ .DP)(reduxStore.getState());
            (0,_lib_handleError__WEBPACK_IMPORTED_MODULE_9__/* .handleError */ .S)(pageData.error);
            return _context.abrupt("return", (_pageData$data = pageData === null || pageData === void 0 ? void 0 : pageData.data) !== null && _pageData$data !== void 0 ? _pageData$data : {});

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 16545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers",
      function () {
        return __webpack_require__(60202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useIdleCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/types.mjs
let UnsupportedBehavior;

(function (UnsupportedBehavior) {
  UnsupportedBehavior[UnsupportedBehavior["Immediate"] = 0] = "Immediate";
  UnsupportedBehavior[UnsupportedBehavior["AnimationFrame"] = 1] = "AnimationFrame";
})(UnsupportedBehavior || (UnsupportedBehavior = {}));



;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/hooks.mjs



function useIdleCallback(callback, {
  unsupportedBehavior = UnsupportedBehavior.AnimationFrame
} = {}) {
  const handle = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if ('requestIdleCallback' in window) {
      handle.current = window.requestIdleCallback(() => callback());
    } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
      handle.current = window.requestAnimationFrame(() => {
        callback();
      });
    } else {
      callback();
    }

    return () => {
      const {
        current: currentHandle
      } = handle;
      handle.current = null;

      if (currentHandle == null) {
        return;
      }

      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(currentHandle);
      } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
        window.cancelAnimationFrame(currentHandle);
      }
    };
  }, [callback, unsupportedBehavior]);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(16545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);